<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/category/index">{{language[106]['Manage Category']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[107]['Create Category']}} </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">

  
 
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[16]['Main Category']}} </label>
            <input  v-model="category.category_name"  style="font-size: small;" class="form-control bdr-rad" >
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[108]['Code']}} </label>
            <input  v-model="category.code"  style="font-size: small;" class="form-control bdr-rad" >
           
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[113]['Message']}} </label>
            <input  v-model="category.message"  style="font-size: small;" class="form-control bdr-rad" >
           
    </div>
  </div>
   

</div>

<br>


                            <h6 class="purchitem mb-2"><b>{{language[111]['Add Sub Category']}} </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                                <th></th>
                              <th>{{language[17]['Sub Category']}} </th>
                              <th>{{language[108]['Code']}} </th>
                              <th>{{language[113]['Message']}} </th>
                           
                              <th > </th>
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                                <tr>
                                <td><b-icon @click="remove" v-show="this.count>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
                                <td><input v-model="detail[0].category_name"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[0].code"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[0].message"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td> <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                            
                            </tr>
                            <tr v-for="key in count" :key="key">
                                <td><b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
                                <td><input v-model="detail[key].category_name"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[key].code"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td><input v-model="detail[key].message"  style="font-size: small;" class="form-control  bdr-rad" ></td>
                                <td> <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
                            
                            </tr>
                            </tbody>

                          </table>
    
                        </div>




  
















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[52]['Create']}}</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           <br><br>
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import httpClient from '@/axios';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadCat()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            language:JSON.parse(authService.isLanguage()),
        total:0,
        selectedOption: null, // Store the selected option
        file: null,

        errors: {},
        mainscats:[],
        subcats:[],
        contractor:{},
        category:{},
        detail:[
      {},  
      ],
      count: 0,
    
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    
          validate(){
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobilePattern = /^\+46\d{2}\d{3}\d{4}$/; 
      this.errors = {};
      if(this.contractor.name == null){
        this.$set(this.errors, 'name', "Contractor Name is required");
      }
      if(this.contractor.main_category == null){
        this.$set(this.errors, 'main_category', "Work Type1 is required");
      }
      if(this.contractor.sub_category == null){
        this.$set(this.errors, 'sub_category', "Work Type2 is required");
      }
      
      if (!emailPattern.test(this.contractor.email)) {
        this.$set(this.errors, 'email', "Please enter a valid email address");
      }
    
      if (!this.contractor.mobile) {
      this.$set(this.errors, 'mobile', "Mobile number is required");
    } else if (!mobilePattern.test(this.contractor.mobile)) {
      this.$set(this.errors, 'mobile', "Please enter a valid 9 or 10-digit mobile number");
    }
  },
            async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcat',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mainscats = data.mainscats;
       this.subcats = data.subcats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  handleFileUpload(event) {
            this.file = event.target.files[0];
        },


    async SaveProduct() {

     // this.validate();

     


      
       try {
         const { data} = await  httpClient.post('/web/api/issuetracking/createcategory',{category:this.category,detail:this.detail},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             //'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/category/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
      
     },
       
     add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },
     

    },

   
    
    }
    
    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
    